import { render } from "./OrderpictureMobile.vue?vue&type=template&id=2f07fd34"
import script from "./OrderpictureMobile.vue?vue&type=script&lang=js"
export * from "./OrderpictureMobile.vue?vue&type=script&lang=js"

import "./OrderpictureMobile.vue?vue&type=style&index=0&id=2f07fd34&lang=css"

import exportComponent from "/Users/dejth/Workspace/nakee-order-detail/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__